export default __webpack_public_path__ + "static/media/KZ.T.05.2331.cb327749.svg";